import "./assets/styles/App.css";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import DeleteAccount from "./pages/DeleteAccount";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* <Route index element={<Home />} /> */}
        <Route path="delete-account" element={<DeleteAccount />} />
        {/* <Route path="blogs" element={<Blogs />} /> */}
        {/* <Route path="*" element={<NoPage />} /> */}
      </Routes>
    </BrowserRouter>
  );
}

export default App;
